'use client';
/**
 * Dependencies
 */
import React from 'react';
import ShoppingModule from '~/app/components/front-page-redesign/shopping-module';
import NerdWalletPlus from '~/app/components/front-page-redesign/nerdwallet-plus/nerdwallet-plus';
import SocialModule from '~/app/components/front-page-redesign/social-module/social-module';
import { Box, CenteredContainer, Text } from '@nerdwallet/currency';
import styles from './front-page-container.module.scss';
import Quiz from '~/app/components/front-page-redesign/quiz';
import Testimonials from '~/app/components/front-page-redesign/testimonials';
import Articles from '~/app/components/front-page-redesign/articles';
import { NewsArticlesQuery } from '~/generated-graphql/generated-types';
import { TreasuryRates } from '~/app/queries/types';

interface Props {
  articlesData?: NewsArticlesQuery | undefined;
  socialVideos?: string[] | undefined;
  treasuryRates?: TreasuryRates;
}

const FrontPageContainer = ({
  articlesData,
  socialVideos,
  treasuryRates,
}: Props) => {
  return (
    <Box className={styles.mainWrapper}>
      <CenteredContainer className={styles.shoppingModuleWithoutBanner}>
        <div className={styles.heading}>
          <div className={styles.headingTitle}>
            <Text component="h1" bold>
              <span className={styles.titleSize}>
                Financial decisions ahead? Let the Nerds do the work.
              </span>
            </Text>
          </div>
        </div>
      </CenteredContainer>
      <Quiz />
      <CenteredContainer className={styles.titleWrapper}>
        <div className={styles.alternativeSubHeading}>
          <Text component="h2" size="large">
            Compare our top picks side by side. Click a tab to get started.
          </Text>
        </div>
        <ShoppingModule />
      </CenteredContainer>
      <Articles articlesData={articlesData} alternativeVersion />
      <NerdWalletPlus
        showNerdWalletPlus
        showBestOfAwards={false}
        treasuryRates={treasuryRates}
      />
      <SocialModule socialVideos={socialVideos} />
      <Testimonials
        backgroundColor="#00482F"
        negativeTopMarginValue={53}
        treasuryRates={treasuryRates}
      />
    </Box>
  );
};

export default FrontPageContainer;
